import LoadingSpinner from '@/components/ui/LoadingSpinner';

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <LoadingSpinner />
  </div>
);

export default PageLoader;
